// Adres API. Lokalnie: REACT_APP_API_URI w .env.development.local (np. http://localhost:5174/),
// żeby `npm start` nie pracował na produkcji. Bez zmiennej: produkcja (build stagingu i produkcji).
export const ApiURI = process.env.REACT_APP_API_URI || "https://tutekapi.azurewebsites.net/";
//  test: "https://tut-test-hah9b7e7g5gaewgu.polandcentral-01.azurewebsites.net/"

// Sekcja rejestru ośrodka w raporcie (etap 2, przed przełączeniem): włączona tylko w buildzie stagingu
// (REACT_APP_SITE_ISSUES_IN_REPORT=true w workflow brave-forest). PDF i dotychczasowe sekcje bez zmian.
export const SiteIssuesInReport = process.env.REACT_APP_SITE_ISSUES_IN_REPORT === "true";
